import { createApp } from "vue";
import { createPinia } from "pinia";

import App from "./App.vue";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import primevue from "primevue/config";
import Notifications from "@kyvg/vue3-notification";
import TabMenu from "primevue/tabmenu";
import Button from "primevue/button";
import Menu from "primevue/menu";
import Toast from "primevue/toast";
import Dialog from "primevue/dialog";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import DataTable from "primevue/datatable";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Textarea from "primevue/textarea";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Dropdown from "primevue/dropdown";
import SplitButton from "primevue/splitbutton";
import Calendar from "primevue/calendar";
import Checkbox from "primevue/checkbox";
import ToastService from "primevue/toastservice";
import { ScalingSquaresSpinner } from "epic-spinners";
import "primevue/resources/primevue.min.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "./styles/index.scss";
import VueGtag from "vue-gtag-next";
const app = createApp(App);

/*
=======================================
    GLOBAL COMPONENTS REGISTRATION
=======================================
*/
app.component("TabMenu", TabMenu);
app.component("PrimeButton", Button);
app.component("PrimeMenu", Menu);
app.component("Toast", Toast);
app.component("PrimeDialog", Dialog);
app.component("InputText", InputText);
app.component("InputNumber", InputNumber);
app.component("DataTable", DataTable);
app.component("TabView", TabView);
app.component("TabPanel", TabPanel);
app.component("PrimeTextarea", Textarea);
app.component("Column", Column);
app.component("ColumnGroup", ColumnGroup);
app.component("Dropdown", Dropdown);
app.component("Calendar", Calendar);
app.component("SplitButton", SplitButton);
app.component("Checkbox", Checkbox);
app.component("ScalingSquaresSpinner", ScalingSquaresSpinner);

app.use(createPinia())
    .use(primevue)
    .use(Notifications)
    .use(VueAxios, axios)
    .use(router)
    .use(ToastService)
    .use(VueGtag, {
        property: {
            id: import.meta.env.VITE_MEASUREMENT_ID,
        },
    })
    .mount("#app");
